import axios from "axios";
import { baseApiUrl } from "../../../env";

const login_URL = `${baseApiUrl}/api/v1/Authentication/Login`;
const rememberLogin_URL = `${baseApiUrl}/api/v1/Authentication/RememberLogin`;
const clearRemember_URL = `${baseApiUrl}/api/v1/Authentication/ClearRemember`;
const logout_URL = `${baseApiUrl}/api/v1/Authentication/Logout`;
const sendOtp_URL = `${baseApiUrl}/api/v1/Authentication/SendOtpCode`;
const changePassword_URL = `${baseApiUrl}/api/v1/Authentication/ChangeUserPassword`;
const verifyOtp_URL = `${baseApiUrl}/api/v1/Authentication/VerifyOtpCode`;

const loginReq = async (userBody) => {
  return axios.post(login_URL, userBody, { withCredentials: true });
};

const rememberLoginReq = async () => {
  return axios.post(rememberLogin_URL, null, { withCredentials: true });
};

const clearRememberReq = async () => {
  return axios.post(clearRemember_URL, null, { withCredentials: true });
};


const logoutReq = async (rememberMe) => {
  return axios.get(`${logout_URL}?rememberMe=${rememberMe}`, { withCredentials: true });
};

const sendOtpReq = async ({ phoneNumber, collectionId }) => {
  return axios.post(
    sendOtp_URL,
    { phoneNumber },
    {
      withCredentials: true,
      headers: {
        ...(collectionId && { CollectionId: collectionId }),
      },
    }
  );
};

const changePasswordReq = async ({ phoneNumber, newPassword, collectionId }) => {
  return axios.post(
    changePassword_URL,
    { phoneNumber, newPassword },
    {
      withCredentials: true,
      headers: {
        ...(collectionId && { CollectionId: collectionId }),
      },
    }
  );
};

const verifyOtpReq = ({ phoneNumber, code, collectionId }) => {
  const headers = collectionId ? { CollectionId: collectionId } : {};
  return axios.post(
    verifyOtp_URL, 
    { phoneNumber, code },
    { headers }
  );
};


export { loginReq, rememberLoginReq, clearRememberReq, logoutReq ,  sendOtpReq,  changePasswordReq , verifyOtpReq};
